// Add body class code
document.body.classList.add("custom-replo-product-template-page");

// View More / View Less toggle code
document.addEventListener("click", function (e) {
  const btn = e.target.closest('[data-class="viewmoebtn"]');
  if (!btn) return;

  const desc = document.querySelector('[data-class="descproduct"]');
  if (!desc) return;

  const isActive = desc.classList.toggle("active");

  const textEl = btn.querySelector("p, span, div") || btn;
  textEl.textContent = isActive ? "View Less..." : "View More...";
});

// Onetime save % code

(function () {
  function handleDiscount() {
    const container = document.querySelector('[data-class~="one-time-discount"]');
    if (!container) return;
    const children = container.querySelectorAll(':scope > div');
    if (children.length < 2) return;
    const labelDiv = children[0];
    const valueDiv = children[1];
    const valueSpan = valueDiv.querySelector('span');
    if (!valueSpan) return;
    const discountValue = valueSpan.textContent.trim();
    if (discountValue === "0%" || discountValue === "") {
      labelDiv.style.display = "none";
      valueDiv.style.display = "none";
    } else {
      labelDiv.style.display = "";
      valueDiv.style.display = "";
    }
  }
  handleDiscount();
  const observer = new MutationObserver(() => {
    handleDiscount();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

// &nbsp space remove code
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('[data-class="descproduct"] p').forEach(p => {
    if (p.innerHTML.replace(/&nbsp;/g, '').trim() === '') {
      p.remove();
    }
  });
});

// area label remove code
window.addEventListener("load", function () {
  document.querySelectorAll('img[aria-label]').forEach(function(img){
    img.alt = img.getAttribute('aria-label');
    img.removeAttribute('aria-label');
  });
});

// Replace logo gif name
// window.addEventListener("load", function () {
//   setTimeout(function(){
//     document.querySelectorAll('img').forEach(img => {
//       if (img.src.includes('73288-647.gif')) {
//         img.alt = "Liquid Health Modal Logo Inner";
//       }
//       if (img.src.includes('73274-251.png')) {
//         img.alt = "Liquid Health Modal Logo";
//       }
//     });
//   }, 1500);
// });

// Remove preloader code
window.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('smc-preloader').forEach(el => el.remove());
});

// Change Rebuy heading tags

function changeRebuyHeading() {
  document.querySelectorAll('h5.rebuy-product-title').forEach(el => {
    const div = document.createElement('div');
    [...el.attributes].forEach(attr => {
      div.setAttribute(attr.name, attr.value);
    });
    while (el.firstChild) {
      div.appendChild(el.firstChild);
    }
    el.replaceWith(div);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  changeRebuyHeading();
  const observer = new MutationObserver(() => {
    observer.disconnect();
    changeRebuyHeading();
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});



// Fix select label code
function fixSelectLabel(){
  document.querySelectorAll('[data-class="delivery_dropdown"]').forEach(select => {
    if (!select.id) {
      select.id = "delivery-select-" + Math.random().toString(36).substr(2,5);
    }
    if (!document.querySelector(`label[for="${select.id}"]`)) {
      const label = document.createElement("label");
      label.setAttribute("for", select.id);
      label.textContent = "Select delivery";
      label.style.position = "absolute";
      label.style.left = "-9999px";
      label.style.color = "#1d1d1d";
      select.parentNode.insertBefore(label, select);
    }
  });
}
document.addEventListener("DOMContentLoaded", fixSelectLabel);
setInterval(fixSelectLabel, 1000);

// Add radio label tag code
window.addEventListener('load', function () {
  const radios = document.querySelectorAll('input[type="radio"]');
  const labelsText = [
    "Subscribe & Save",
    "Buy Once"
  ];
  radios.forEach((radio, index) => {
    if (radio.closest('label')) return;
    const label = document.createElement('label');
    const text = document.createTextNode(labelsText[index] || 'Option');
    radio.parentNode.insertBefore(label, radio);
    label.appendChild(radio);
    label.appendChild(text);
    radio.removeAttribute('aria-hidden');
  });
});

// Add error pop up for one time product
(function () {
  if (window.__reploSellingPlanModalInstalled) return;
  window.__reploSellingPlanModalInstalled = true;

  var addToCartClicked = false;

  function showModal() {
    if (document.getElementById('replo-selling-plan-error')) return;

    var modal = document.createElement('div');
    modal.id = 'replo-selling-plan-error';

    modal.innerHTML = `
      <div class="sp-overlay"></div>
      <div class="sp-dialog" role="dialog" aria-modal="true">
        <button type="button" class="sp-close" aria-label="Close modal">
          &times;
        </button>
        <div class="sp-content">
          <div class="sp-alert-icon">
            <span>!</span>
          </div>
          <h2>Cart Error</h2>
          <p>Variant can only be purchased with a selling plan.</p>
        </div>
        <div class="sp-footer">
          <button type="button" class="sp-okay">Okay</button>
        </div>
      </div>
    `;

  
    document.body.appendChild(modal);

    function close() {
      modal.remove();
      style.remove();
    }

     // Close using the X button.
    modal.querySelector('.sp-close').addEventListener('click', close);

    // Close using the Okay button.
    modal.querySelector('.sp-okay').addEventListener('click', close);

    // Close by clicking the overlay.
    modal.querySelector('.sp-overlay').addEventListener('click', close);

    // modal.querySelector('button').addEventListener('click', close);
    // modal.querySelector('.sp-overlay').addEventListener('click', close);
  }

  function checkResponse(text) {
    if (
      addToCartClicked &&
      typeof text === 'string' &&
      /variant can only be purchased with a selling plan/i.test(text)
    ) {
      showModal();
    }
  }

  // Detect clicks on the Replo Add to Cart button.
  document.addEventListener('click', function (event) {
    var button = event.target.closest(
      'button[data-replo-add-product-variant-to-cart]'
    );

    if (!button) return;

    addToCartClicked = true;

    // Reset after the current add-to-cart operation.
    setTimeout(function () {
      addToCartClicked = false;
    }, 10000);
  }, true);

  // Monitor fetch requests to Shopify's cart endpoint.
  var originalFetch = window.fetch;

  window.fetch = async function () {
    var args = arguments;

    var url = typeof args[0] === 'string'
      ? args[0]
      : args[0] && args[0].url || '';

    var response = await originalFetch.apply(this, args);

    if (
      addToCartClicked &&
      /\/cart\/add(?:\.js)?(?:\?|$)/i.test(url)
    ) {
      response.clone().text()
        .then(checkResponse)
        .catch(function () {});
    }

    return response;
  };

  // Monitor XMLHttpRequest cart requests.
  var originalOpen = XMLHttpRequest.prototype.open;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__reploCartAdd =
      /\/cart\/add(?:\.js)?(?:\?|$)/i.test(String(url));

    return originalOpen.apply(this, arguments);
  };

  var originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.send = function () {
    if (this.__reploCartAdd && addToCartClicked) {
      this.addEventListener('load', function () {
        checkResponse(this.responseText);
      });
    }

    return originalSend.apply(this, arguments);
  };
})();

// document.addEventListener("click", function(e) {

//   if (e.target.closest("#yotpo-reviews-star-ratings-widget, .yotpo-sr-bottom-line-summary")) {
//     document.querySelector("#alchemy-modal-body-child")
//       .style.removeProperty("display");
//   }
//   if (e.target.closest("#alchemy-modal-body-child .yotpo-header-container #yotpo-main-widget-btn")) {
//     document.querySelector("#alchemy-modal-body-child")
//       .style.setProperty("display", "none", "important");
//     const bodyObserver = new MutationObserver(function() {
//       if (document.body.classList.contains("replo-modal-after-open")) {
//         document.body.classList.remove("replo-modal-after-open");
//       }
//     });
//     bodyObserver.observe(document.body, {
//       attributes: true,
//       attributeFilter: ["class"]
//     });
//   }
// }, true);

document.addEventListener("click", function (e) {
  const rating = e.target.closest('[data-class="product-rating"]');
  if (!rating) return;

  const reviewSection = document.querySelector('[data-class="yopto-review-section"]');
  if (!reviewSection) return;

  reviewSection.scrollIntoView({
    behavior: "smooth",
    block: "start"
  });
});


